import { Tooltip } from 'bootstrap';

const SCRIPT_NAME = 'tooltip.js';

/**
 * Initialisiert Bootstrap-Tooltips für alle Elemente mit dem Attribut `data-bs-toggle="tooltip"`
 */
export function initTooltips() {
    utils.consoleLog(SCRIPT_NAME, 'Initialisierung gestartet');

    // Alle Trigger-Elemente für Tooltips finden
    const TOOLTIP_TRIGGER_LIST = document.querySelectorAll('[data-bs-toggle="tooltip"], [data-bs-tooltip="true"]');

    if (TOOLTIP_TRIGGER_LIST.length === 0) {
        utils.consoleLog(SCRIPT_NAME, 'Keine Elemente mit [data-bs-toggle="tooltip"] gefunden');
        return; // Keine Tooltips vorhanden, keine Aktion notwendig
    }

    utils.consoleLog(SCRIPT_NAME, `Tooltip-Trigger gefunden: ${TOOLTIP_TRIGGER_LIST.length}`);

    // Tooltips initialisieren
    [...TOOLTIP_TRIGGER_LIST].forEach(tooltipTriggerEl => {
        new Tooltip(tooltipTriggerEl); // Bootstrap Tooltip direkt verwenden
        utils.consoleLog(SCRIPT_NAME, 'Tooltip initialisiert', tooltipTriggerEl);
    });

    utils.consoleLog(SCRIPT_NAME, 'Initialisierung abgeschlossen');
}